import React from "react";

export const ProgressBar = ({
  progress,
  height,
  width,
  primaryColor = "#f70",
  secondaryColor = "#EEE",
  styleInner,
  styleOuter,
}) => (
  <div
    style={{
      ...styleOuter,
      width: width || "100%",
      height,
      background: secondaryColor,
    }}
  >
    <div
      style={{
        ...styleInner,
        height: "100%",
        width: Math.min(progress, 1.0) * 100 + "%",
        background: primaryColor,
      }}
    />
  </div>
);
